import { useState, useEffect } from "react";
import { FormControl, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { CancelOutlined as CancelOutlinedIcon } from "@mui/icons-material";

export const Input = ({ label, placeholder, value, disabled, required, onChange, hasError, errorText, startAdornment }) => {
  const ariaLabel = label.replace(" ", "_").toLowerCase();
  const [hasFocus, setHasFocus] = useState(false);

  useEffect(() => {
    const input = document.getElementById(ariaLabel);
    if (input != null) input.setAttribute("aria-label", ariaLabel);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (hasError) {
      const inputs = document.getElementsByTagName("input");
      if (inputs.length > 0) {
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].removeAttribute("aria-invalid");
        }
      }
    }
  }, [hasError]);

  return (
    <>
      <Typography className="fieldLabel">
        {label}
        {required && " *"}
      </Typography>
      <FormControl fullWidth>
        <TextField
          value={value}
          variant="outlined"
          {...(label != null && { id: ariaLabel })}
          {...(!hasFocus && value === "" && { label: placeholder })}
          onChange={onChange}
          disabled={disabled}
          size="small"
          {...(hasError && {
            error: true,
            helperText: errorText,
          })}
          {...(disabled && { variant: "filled" })}
          onFocus={() => setHasFocus(true)}
          onBlur={() => setHasFocus(false)}
          InputProps={{
            ...((hasFocus || (value != null && value !== "")) && { startAdornment: startAdornment }),
            ...(value != null &&
              value !== "" && {
                endAdornment: (
                  <InputAdornment position="end" sx={{ marginRight: "20px" }}>
                    <IconButton title="Cancella" edge="end" onClick={() => onChange({ target: { value: "" } })}>
                      <CancelOutlinedIcon sx={{ color: "black", ...(hasError && { color: "#871d1d" }) }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }),
          }}
        />
      </FormControl>
    </>
  );
};
